/*!
 * KoliBri - The accessible HTML-Standard
 */
import { E as Ee, K as KeyEnum, T as TagEnum, L as Log } from './common-D-vggmh2.js';
export { a as KoliBriDevHelper, R as getDefaultThemeName } from './common-D-vggmh2.js';
export { s as setCurrentLocation } from './ariaCurrentService-YoLNpD5S.js';
import { i as isInitialized } from './bootstrap-Bfno1qh2.js';
export { b as bootstrap, r as register } from './bootstrap-Bfno1qh2.js';
import { K as KolToastContainerTag } from './component-names-DwvrfFak.js';
export { B as BEM } from './bem-registry-3ondDImf.js';
export { K as KolEvent } from './events-BhfZTW2e.js';
export { i as isTooltipOpen } from './tooltip-open-tracking-D3tCiiGP.js';
import './i18n-C73LqPIs.js';

const KoliBri = new Ee('kol', KeyEnum, TagEnum);

class ToasterService {
    constructor(document, options) {
        var _a;
        this.document = document;
        this.options = options;
        this.toastContainerElement = this.document.createElement(KolToastContainerTag);
        this.document.body.prepend(this.toastContainerElement);
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.defaultVariant) {
            Log.info(`ToasterService: Default variant is deprecated. Use 'card' variant for all toasts instead.`);
        }
    }
    static getInstance(document, options) {
        if (!isInitialized()) {
            throw new Error('Toaster: Call KoliBri bootstrap/register method first.');
        }
        let instance = this.instances.get(document);
        if (!instance) {
            instance = new ToasterService(document, options);
            this.instances.set(document, instance);
        }
        return instance;
    }
    dispose() {
        const element = this.toastContainerElement;
        if (element) {
            this.toastContainerElement = undefined;
            element.remove();
        }
        else {
            Log.warn('Toaster service is already disposed.');
        }
    }
    enqueue(toast) {
        if (this.toastContainerElement && typeof this.toastContainerElement.enqueue === 'function') {
            return this.toastContainerElement.enqueue(toast);
        }
    }
    closeAll(immediate = false) {
        if (this.toastContainerElement && typeof this.toastContainerElement.closeAll === 'function') {
            void this.toastContainerElement.closeAll(immediate);
        }
    }
}
ToasterService.instances = new Map();

var Bundesministerium;
(function (Bundesministerium) {
    Bundesministerium["Die Bundesregierung"] = "BReg";
    Bundesministerium["Bundesministerium der Finanzen"] = "BMF";
    Bundesministerium["Bundesministerium des Innern, f\u00FCr Bau und Heimat"] = "BMI";
    Bundesministerium["Ausw\u00E4rtiges Amt"] = "AA";
    Bundesministerium["Bundesministerium f\u00FCr Wirtschaft und Energie"] = "BMWi";
    Bundesministerium["Bundesministerium der Justiz und f\u00FCr Verbraucherschutz"] = "BMJV";
    Bundesministerium["Bundesministerium f\u00FCr Arbeit und Soziales"] = "BMAS";
    Bundesministerium["Bundesministerium der Verteidigung"] = "BMVg";
    Bundesministerium["Bundesministerium f\u00FCr Ern\u00E4hrung und Landwirtschaft"] = "BMEL";
    Bundesministerium["Bundesministerium f\u00FCr Familie, Senioren, Frauen und Jugend"] = "BMFSFJ";
    Bundesministerium["Bundesministerium f\u00FCr Gesundheit"] = "BMG";
    Bundesministerium["Bundesministerium f\u00FCr Verkehr und digitale Infrastruktur"] = "BMVI";
    Bundesministerium["Bundesministerium f\u00FCr Umwelt, Naturschutz und nukleare Sicherheit"] = "BMU";
    Bundesministerium["Bundesministerium f\u00FCr Bildung und Forschung"] = "BMBF";
    Bundesministerium["Bundesministerium f\u00FCr wirtschaftliche Zusammenarbeit und Entwicklung"] = "BMZ";
})(Bundesministerium || (Bundesministerium = {}));
const BUNDESMINISTERIEN = Object.getOwnPropertyNames(Bundesministerium);
var Bundesamt;
(function (Bundesamt) {
    Bundesamt["Beschaffungsamt des Bundesministeriums des Innern"] = "BeschA";
    Bundesamt["Bundesamt f\u00FCr Ausr\u00FCstung, Informationstechnik und Nutzung der Bundeswehr"] = "BAAINBw";
    Bundesamt["Bundesamt f\u00FCr \u00E4u\u00DFere Restitutionen"] = "BAR";
    Bundesamt["Bundesamt f\u00FCr Bauwesen und Raumordnung"] = "BBR";
    Bundesamt["Bundesamt f\u00FCr Bev\u00F6lkerungsschutz und Katastrophenhilfe"] = "BBK";
    Bundesamt["Bundesamt f\u00FCr Familie und zivilgesellschaftliche Aufgaben"] = "BAFzA";
    Bundesamt["Bundesamt f\u00FCr G\u00FCterverkehr"] = "BAG";
    Bundesamt["Bundesamt f\u00FCr Justiz"] = "BfJ";
    Bundesamt["Bundesamt f\u00FCr Kartographie und Geod\u00E4sie"] = "BKG";
    Bundesamt["Bundesamt f\u00FCr kerntechnische Entsorgungssicherheit"] = "BASE";
    Bundesamt["Bundesamt f\u00FCr Migration und Fl\u00FCchtlinge"] = "BAMF";
    Bundesamt["Bundesamt f\u00FCr Sicherheit in der Informationstechnik"] = "BSI";
    Bundesamt["Bundesamt f\u00FCr Verbraucherschutz und Lebensmittelsicherheit"] = "BVL";
    Bundesamt["Bundesamt f\u00FCr Verfassungsschutz"] = "BfV";
    Bundesamt["Bundesamt f\u00FCr Wirtschaft und Ausfuhrkontrolle"] = "BAFA";
    Bundesamt["Bundesamt f\u00FCr zentrale Dienste und offene Verm\u00F6gensfragen"] = "BADV";
    Bundesamt["Bundesanstalt f\u00FCr Verwaltungsdienstleistungen"] = "BAV";
    Bundesamt["Bundesarchiv"] = "BArch";
    Bundesamt["Bundesaufsichtsamt f\u00FCr Flugsicherung"] = "BAF";
    Bundesamt["Bundesausgleichsamt"] = "BAA";
    Bundesamt["Bundeskartellamt"] = "BKartA";
    Bundesamt["Bundeskriminalamt"] = "BKA";
    Bundesamt["Bundesnachrichtendienst"] = "BND";
    Bundesamt["Bundesnetzagentur f\u00FCr Elektrizit\u00E4t, Gas, Telekommunikation, Post und Eisenbahnen"] = "BNetzA";
    Bundesamt["Bundespolizeipr\u00E4sidium"] = "BPOLP";
    Bundesamt["Bundespr\u00FCfstelle f\u00FCr jugendgef\u00E4hrdende Medien"] = "BPjM";
    Bundesamt["Bundessortenamt"] = "BSA";
    Bundesamt["Bundessprachenamt"] = "BSprA";
    Bundesamt["Bundesamt f\u00FCr Soziale Sicherung"] = "BAS";
    Bundesamt["Bundesverwaltungsamt"] = "BVA";
    Bundesamt["Bundeszentralamt f\u00FCr Steuern"] = "BZSt";
    Bundesamt["Deutsches Patent- und Markenamt"] = "DPMA";
    Bundesamt["Eisenbahn-Bundesamt"] = "EBA";
    Bundesamt["Generalzolldirektion"] = "GZD";
    Bundesamt["Milit\u00E4rischer Abschirmdienst"] = "MAD";
    Bundesamt["Zentrale Stelle f\u00FCr Informationstechnik im Sicherheitsbereich"] = "ZITiS";
})(Bundesamt || (Bundesamt = {}));
const BUNDESAEMTER = Object.getOwnPropertyNames(Bundesamt);
var Bundesanstalt;
(function (Bundesanstalt) {
    Bundesanstalt["Informationstechnikzentrum Bund"] = "ITZBund";
    Bundesanstalt["Bundesanstalt f\u00FCr den Digitalfunk der Beh\u00F6rden und Organisationen mit Sicherheitsaufgaben"] = "BDBOS";
    Bundesanstalt["Bundesanstalt f\u00FCr Landwirtschaft und Ern\u00E4hrung"] = "BLE";
    Bundesanstalt["Bundesanstalt Technisches Hilfswerk"] = "THW";
    Bundesanstalt["Bundesinstitut f\u00FCr Arzneimittel und Medizinprodukte"] = "BfArM";
    Bundesanstalt["Bundesinstitut f\u00FCr Bev\u00F6lkerungsforschung"] = "BiB";
    Bundesanstalt["Bundesinstitut f\u00FCr Sportwissenschaft"] = "BISp";
})(Bundesanstalt || (Bundesanstalt = {}));
const BUNDESANSTALTEN = Object.getOwnPropertyNames(Bundesanstalt);
const BUND_LOGO_TEXT_MAP = new Map();
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Die Bundesregierung'], ['Die', 'Bundesregierung']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium der Finanzen'], ['Bundesministerium', 'der Finanzen']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium des Innern, für Bau und Heimat'], ['Bundesministerium', 'des Inneren, für Bau', 'und Heimat']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Auswärtiges Amt'], ['Auswärtiges Amt']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Wirtschaft und Energie'], ['Bundesministerium', 'für Wirtschaft', 'und Energie']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium der Justiz und für Verbraucherschutz'], [
    'Bundesministerium',
    'der Justiz und',
    'für Verbraucherschutz',
]);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Arbeit und Soziales'], ['Bundesministerium', 'für Arbeit und Soziales']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium der Verteidigung'], ['Bundesministerium', 'der Verteidigung']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Bildung und Forschung'], ['Bundesministerium', 'für Bildung', 'und Forschung']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Ernährung und Landwirtschaft'], ['Bundesministerium', 'für Ernährung', 'und Landwirtschaft']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Familie, Senioren, Frauen und Jugend'], [
    'Bundesministerium',
    'für Familie, Senioren, Frauen',
    'und Jugend',
]);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Gesundheit'], ['Bundesministerium', 'für Gesundheit']);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Umwelt, Naturschutz und nukleare Sicherheit'], [
    'Bundesministerium',
    'für Umwelt, Naturschutz',
    'und nukleare Sicherheit',
]);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für Verkehr und digitale Infrastruktur'], [
    'Bundesministerium',
    'für Verkehr und',
    'digitale Infrastruktur',
]);
BUND_LOGO_TEXT_MAP.set(Bundesministerium['Bundesministerium für wirtschaftliche Zusammenarbeit und Entwicklung'], [
    'Bundesministerium',
    'für wirtschaftliche Zusammenarbeit',
    'und Entwicklung',
]);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Beschaffungsamt des Bundesministeriums des Innern'], ['Beschaffungsamt', 'des Bundesministeriums', 'des Innern']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Ausrüstung, Informationstechnik und Nutzung der Bundeswehr'], []);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für äußere Restitutionen'], []);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Bauwesen und Raumordnung'], []);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Bevölkerungsschutz und Katastrophenhilfe'], ['Bundesamt', 'für Bevölkerungsschutz', 'und Katastrophenhilfe']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Familie und zivilgesellschaftliche Aufgaben'], [
    'Bundesamt',
    'für Familie und',
    'zivilgesellschaftliche Aufgaben',
]);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Güterverkehr'], ['Bundesamt', 'für Güterverkehr']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Justiz'], ['Bundesamt für', 'Justiz']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Kartographie und Geodäsie'], ['Bundesamt für', 'Kartographie und Geodäsie']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für kerntechnische Entsorgungssicherheit'], ['Bundesamt für', 'kerntechnische', 'Entsorgungssicherheit']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Migration und Flüchtlinge'], ['Bundesamt', 'für Migration', 'und Flüchtlinge']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Sicherheit in der Informationstechnik'], ['Bundesamt', 'für Sicherheit in der', 'Informationstechnik']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Verbraucherschutz und Lebensmittelsicherheit'], [
    'Bundesamt für',
    'Verbraucherschutz und',
    'Lebensmittelsicherheit',
]);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Verfassungsschutz'], ['Bundesamt für', 'Verfassungsschutz']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Wirtschaft und Ausfuhrkontrolle'], ['Bundesamt', 'für Wirtschaft', 'Ausfuhrkontrolle']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für zentrale Dienste und offene Vermögensfragen'], [
    'Bundesamt',
    'für zentrale Dienste und',
    'offene Vermögensfragen',
]);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesanstalt für Verwaltungsdienstleistungen'], ['Bundesanstalt', 'für Verwaltungsdienstleistungen']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesarchiv'], ['Das', 'Bundesarchiv']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesaufsichtsamt für Flugsicherung'], ['Bundesaufsichtsamt', 'für Flugsicherung']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesausgleichsamt'], ['Bundesausgleichsamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundeskartellamt'], ['Bundeskartellamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundeskriminalamt'], ['Bundeskriminalamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesnachrichtendienst'], ['Bundesnachrichtendienst']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesnetzagentur für Elektrizität, Gas, Telekommunikation, Post und Eisenbahnen'], ['Bundesnetzagentur']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundespolizeipräsidium'], ['Bundespolizeipräsidium']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesprüfstelle für jugendgefährdende Medien'], ['Bundesprüfstelle', 'für jugendgefährdende', 'Medien']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundessortenamt'], ['Bundessortenamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundessprachenamt'], ['Bundessprachenamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesamt für Soziale Sicherung'], ['Bundesamt', 'für Soziale Sicherung']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundesverwaltungsamt'], ['Bundesverwaltungsamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Bundeszentralamt für Steuern'], ['Bundeszentralamt', 'für Steuern']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Deutsches Patent- und Markenamt'], ['Deutsches', 'Patent- und Markenamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Eisenbahn-Bundesamt'], ['Eisenbahn-Bundesamt']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Generalzolldirektion'], ['Generalzolldirektion']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Militärischer Abschirmdienst'], ['Bundesamt für den', 'Militärischen Abschirmdienst']);
BUND_LOGO_TEXT_MAP.set(Bundesamt['Zentrale Stelle für Informationstechnik im Sicherheitsbereich'], [
    'Zentrale Stelle',
    'für Informationstechnik',
    'im Sicherheitsbereich',
]);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Informationstechnikzentrum Bund'], ['Informations', 'Technik', 'Zentrum Bund']);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesanstalt für den Digitalfunk der Behörden und Organisationen mit Sicherheitsaufgaben'], [
    'Bundesanstalt',
    'für den Digitalfunk der Behörden und',
    'Organisationen mit Sicherheitsaufgaben',
]);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesanstalt für Landwirtschaft und Ernährung'], ['Bundesanstalt für', 'Landwirtschaft und Ernährung']);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesanstalt Technisches Hilfswerk'], ['Bundesanstalt', 'Technisches Hilfswerk']);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesinstitut für Arzneimittel und Medizinprodukte'], ['Bundesinstitut', 'für Arzneimittel', 'und Medizinprodukte']);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesinstitut für Bevölkerungsforschung'], ['Bundesinstitut', 'für Bevölkerungsforschung']);
BUND_LOGO_TEXT_MAP.set(Bundesanstalt['Bundesinstitut für Sportwissenschaft'], ['Bundesinstitut', 'für Sportwissenschaft']);

export { BUNDESAEMTER, BUNDESANSTALTEN, BUNDESMINISTERIEN, BUND_LOGO_TEXT_MAP, Bundesamt, Bundesanstalt, Bundesministerium, KoliBri, ToasterService, isInitialized };
//# sourceMappingURL=index.js.map
